var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pageviewholder",
      style: { width: _vm.boxWidth + "px", height: _vm.boxHeight + "px" },
    },
    [
      _c(
        "div",
        {
          class: { scaleOffset: _vm.smartZoom },
          style: {
            top: _vm.scaleOffsetTop + "px",
            left: _vm.scaleOffsetLeft + "px",
          },
          attrs: { id: "scaleoffset" },
        },
        [
          _c("PageBackgroundView", {
            attrs: {
              "page-model": _vm.pageModel,
              scaling: _vm.scaling,
              "show-bleed": _vm.showBleed,
              "show-mask": _vm.showMask,
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.visiblePageObjects, function (objectModel, index) {
            return _c("PageObjectView", {
              key: index,
              attrs: {
                "object-model": objectModel,
                "page-model": _vm.pageModel,
                scaling: _vm.scaling,
                "show-bleed": _vm.showBleed,
                "show-mask": _vm.showMask,
              },
            })
          }),
          _vm._v(" "),
          _vm.addressModel
            ? _c("PageAddressView", {
                attrs: {
                  "address-model": _vm.addressModel,
                  "page-model": _vm.pageModel,
                  scaling: _vm.scaling,
                  "show-bleed": _vm.showBleed,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showOverlay
            ? _c("PageOverlayView", {
                attrs: {
                  "page-model": _vm.pageModel,
                  scaling: _vm.scaling,
                  "show-bleed": _vm.showBleed,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("PageInteractionView", {
            attrs: {
              draggable: _vm.draggable,
              editable: true,
              "page-model": _vm.pageModel,
              "page-objects": _vm.pageObjects,
              resizable: _vm.resizable,
              rotatable: _vm.rotatable,
              scaling: _vm.scaling,
              "show-bleed": _vm.showBleed,
              "show-depth": true,
              "template-positions-available": _vm.templatePositionsAvailable,
            },
          }),
          _vm._v(" "),
          _vm.showMessage || _vm.showAddress
            ? _c("div", { staticClass: "showTools" }, [
                _vm.showMessage
                  ? _c("div", { staticClass: "buttonbox" }, [
                      _c(
                        "button",
                        {
                          staticClass: "toolbutton editmessage",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.editMessage.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.Translation.messageButtonText) +
                              "\n\t\t\t\t"
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showAddress
                  ? _c("div", { staticClass: "buttonbox" }, [
                      _c(
                        "button",
                        {
                          staticClass: "toolbutton editaddress",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.editAddress.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.Translation.addressButtonText) +
                              "\n\t\t\t\t"
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }